import { updateItems } from '@/mocks/home';

const typeStyles: Record<string, string> = {
  '更新': 'bg-primary-100 text-primary-700',
  '新剧': 'bg-accent-100 text-accent-700',
  '完结': 'bg-secondary-100 text-secondary-700',
  '公告': 'bg-foreground-100 text-foreground-700',
  '专题': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            最新动态
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">实时掌握最新剧集上线和平台动态</p>
        </div>
        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300/60" />
          <div className="space-y-4">
            {updateItems.map((item, i) => (
              <div key={i} className="relative flex items-start gap-4 pl-12">
                <div className="absolute left-[11px] top-2 w-[17px] h-[17px] rounded-full border-[3px] border-background-50 bg-primary-500 flex-shrink-0" />
                <div className="flex-1 bg-background-50 rounded-xl border border-background-200/70 p-4 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className={`px-1.5 py-0.5 rounded text-[10px] font-semibold whitespace-nowrap ${typeStyles[item.type] || typeStyles['更新']}`}>
                      {item.type}
                    </span>
                  </div>
                  <p className="text-sm font-medium text-foreground-800">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}